module.exports = __webpack_public_path__ + "img/sm.3e2df299.svg";